import React, { useState, useEffect, useMemo } from "react";
import { Dropdown } from "react-bootstrap";
import moment from "moment";
import useDropdown from "../../../hooks/dropdown.hook";

import YearMonthDropdown from "../../test/year-month.dropdown";
import { DATE_FORMAT } from "../../../constants/app.constants";

const MyDatePicker = (props) => {
  const {
    disableFutureDates,
    disablePreviousDates,
    minDate,
    onOpen,
    disableDatePicker = false,
    dateFormat = DATE_FORMAT,
  } = props;
  const dateFormatFixed = dateFormat.toUpperCase();
  
  // Generate a unique id if one isn't provided
  const componentId = useMemo(() => {
    return props.id || `date-picker-${Math.random().toString(36).substr(2, 9)}`;
  }, [props.id]);
  
  const [selectedDate, setSelectedDate] = useState(
    moment().format(dateFormatFixed)
  );

  const [firstLoad, setFirstLoad] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const { isOpen, refBtn, refMenu, setIsOpen } = useDropdown({ disableClickOutside: false });

  useEffect(() => {
    if (!firstLoad) return;
    setFirstLoad(true);
    drawCalender();
  }, [selectedDate]);
  useEffect(() => {
    if (props.selected && props.selected !== "Invalid date") {
      setSelectedDate(props.selected);
      setInputValue(props.selected);
    } else {
      setSelectedDate(moment().format(dateFormatFixed));
      setInputValue(moment().format(dateFormatFixed));
    }
  }, [props.selected]);

  useEffect(() => {
    if (!props.setIsOpenState) return;
    props.setIsOpenState(isOpen);
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    if (onOpen) onOpen();
  }, [isOpen]);

  function getValuefromLiTag() {
    let wrapper = document.getElementById(`hg-date-wrapper${componentId}`);

    if (!wrapper) return;

    wrapper.addEventListener("click", (e) => {
      const months_list = {
        January: "01",
        February: "02",
        March: "03",
        April: "04",
        May: "05",
        June: "06",
        July: "07",
        August: "08",
        September: "09",
        October: "10",
        November: "11",
        December: "12",
      };

      let currentDateData = document.querySelector(`.current-date.${componentId}`);

      if (currentDateData) {
        let month = currentDateData.innerText.split(" ")[0];
        let selected_month = months_list[month];
        let year = currentDateData.innerText.split(" ")[1];

        if (e.target.id === "date-value") {
          const date = moment(`${selected_month}/${e.target.value}/${year}`, 'MM/DD/YYYY').format(dateFormatFixed);
          setSelectedDate(date);
          setInputValue(date);
          props.onChange(date);
          setUpdatedDate("");

          const element = document.getElementById(componentId);
          if (element) {
            element.click();
          }
        }
      }
    });
  }

  function drawCalender() {
    const daysTag = document.querySelector(`.days.${componentId}`);
    var currentDate = document.querySelector(`.current-date.${componentId}`);
    var prevNextIcon = document.querySelectorAll(".icons span");

    // getting new date, current year and month
    let date = moment(selectedDate, dateFormatFixed).toDate();
    let currYear = date.getFullYear();
    let currMonth = date.getMonth();

    // storing full name of all months in array
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const renderCalendar = () => {
      let firstDayofMonth = moment(date, dateFormatFixed).startOf('month').day(); // getting first day of month
      let lastDateofMonth = moment(date, dateFormatFixed).endOf('month').date(); // getting last date of month
      let lastDayofMonth = moment(date, dateFormatFixed).endOf('month').day(); // getting last day of month
      let lastDateofLastMonth = moment(date, dateFormatFixed).subtract(1, 'month').endOf('month').date(); // getting last date of previous month
      let liTag = "";

      for (let i = firstDayofMonth; i > 0; i--) {
        // creating li of previous month last days
        liTag += `<li class="inactive">${lastDateofLastMonth - i + 1}</li>`;
      }
      const selectedDateObj = moment(selectedDate, dateFormatFixed).toDate();
      for (let i = 1; i <= lastDateofMonth; i++) {
        // creating li of all days of current month
        // adding active className to li if the current day, month, and year matched
        let isToday =
          i === selectedDateObj.getDate() &&
            currMonth === selectedDateObj.getMonth() &&
            currYear === selectedDateObj.getFullYear()
            ? "active"
            : "";
        var currentCheckDate = new Date();
        let isDisabled = false;
        if (minDate) {
          const minMoment = moment(minDate, dateFormat, true);
          if (minMoment.isValid()) {
            const currentDateMoment = moment([currYear, currMonth, i]);
            isDisabled = currentDateMoment.isBefore(minMoment, 'day');
          }
        }

        // Get the current date
        var currentCheckDay = currentCheckDate.getDate();

        // Create another Date object representing the previous date
        var previousCheckDate = new Date();
        previousCheckDate.setDate(currentCheckDay - 1);

        if (
          disableFutureDates &&
          new Date(currYear, currMonth, i) > new Date()
        ) {
          liTag += `<li class="inactive">${i}</li>`;
        } else if (
          disablePreviousDates &&
          new Date(currYear, currMonth, i) < previousCheckDate
        ) {
          liTag += `<li class="inactive">${i}</li>`;
        } else {
          liTag += `<li class="${isToday} ${isDisabled ? 'inactive' : ''}" id="date-value" value=${i}>${i}</li>`;
        }
        // liTag += `<li class="${isToday}" id="date-value" value=${i}>${i}</li>`;
      }

      for (let i = lastDayofMonth; i < 6; i++) {
        // creating li of next month first days
        liTag += `<li class="inactive">${i - lastDayofMonth + 1}</li>`;
      }
      if (!currentDate) return;
      currentDate.innerText = `${months[currMonth]} ${currYear}`; // passing current mon and yr as currentDate text

      daysTag.innerHTML = liTag;
    };
    renderCalendar();

    prevNextIcon.forEach((icon) => {
      // getting prev and next icons
      icon.addEventListener("click", () => {
        // adding click event on both icons
        // if clicked icon is previous icon then decrement current month by 1 else increment it by 1
        currMonth = icon.id === "prev" ? currMonth - 1 : currMonth + 1;

        if (currMonth < 0) {
          currMonth = 11;  // Set to December
          currYear -= 1;   // Decrement year
        } else if (currMonth > 11) {
          currMonth = 0;   // Set to January
          currYear += 1;   // Increment year
        }

        // Update the date object with new year and month
        date = moment(`${currMonth + 1}/01/${currYear}`, 'MM/DD/YYYY').toDate();

        renderCalendar(); // calling renderCalendar function
      });
    });
  }
  function convertToDate(input, format = dateFormatFixed) {
    // Regular expression to match date formats with any separator
    const datePattern = /^(\d{1,2})[/.-](\d{1,2})[/.-](\d{2,4})$/;
    const match = input.match(datePattern);

    if (!match) {
      return ""; // Return empty string if input does not match the pattern
    }

    let [_, first, second, year] = match;

    // Determine which numbers represent day/month based on format
    let day, month;
    if (format.startsWith('DD')) {
      day = first;
      month = second;
    } else if (format.startsWith('MM')) {
      month = first;
      day = second;
    } else {
      return ""; // Invalid format
    }

    // Convert day, month, year to numbers
    day = parseInt(day, 10);
    month = parseInt(month, 10);
    year = parseInt(year, 10);

    // If year is given in two digits, assume 20xx
    if (year < 100) {
      year += 2000;
    }

    // Check if month is valid
    if (month < 1 || month > 12) {
      return ""; // Return empty string if month is not valid
    }

    // Check if day is valid for the given month
    const daysInMonth = [
      31,
      isLeapYear(year) ? 29 : 28,
      31,
      30,
      31,
      30,
      31,
      31,
      30,
      31,
      30,
      31,
    ];

    if (day < 1 || day > daysInMonth[month - 1]) {
      return ""; // Return empty string if day is not valid for the month
    }

    // Format day and month to two digits
    const formattedDay = day.toString().padStart(2, "0");
    const formattedMonth = month.toString().padStart(2, "0");
    const formattedYear = year.toString();

    // Return the date in the specified format
    if (format.startsWith('DD')) {
      return `${formattedDay}/${formattedMonth}/${formattedYear}`;
    } else {
      return `${formattedMonth}/${formattedDay}/${formattedYear}`;
    }
  }

  // Helper function to check if a year is a leap year
  function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  }

  const [updatedDate, setUpdatedDate] = useState("");

  const handleChange = (closeDropdown) => {
    const isCorrect = moment(inputValue, dateFormatFixed, true).isValid();
    const isCorrectShort = moment(inputValue, dateFormatFixed.replace(/YYYY$/, 'YY'), true).isValid();
    if (!isCorrect && !isCorrectShort) return;

    let formattedDate = inputValue;
    if (isCorrectShort) {
      formattedDate = moment(inputValue, dateFormatFixed.replace(/YYYY$/, 'YY')).format(dateFormatFixed);
    }

    props.onChange(formattedDate, "date");
    if (closeDropdown) {
      document.body.click();
    }
  }

  const handleBlur = () => {
    if (inputValue !== selectedDate) {
      handleChange()
    }
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === 'Tab') {
      handleChange(true)
    }
  };

  const selectedYear = moment(selectedDate).year();
  const selectedMonth = moment(selectedDate).month() + 1;

  return (
    <div className="w-100">
      <Dropdown
        show={isOpen}
        className={`${disableDatePicker
            ? "highground-datpicker-disabled"
            : "highground-datpicker"
          } ${props.DropdownClassName ?? ""} radius-4 ${props.isError ? props?.errorStyle ?? "input-error" : ""
          } my-dropdown`}
        style={{ border: "2px solid red !important" }}
        id={componentId}
        tabIndex={-1}
        onToggle={(e) => {
          if (e) {
            setFirstLoad(true);
            setTimeout(() => {
              drawCalender();
              getValuefromLiTag();
              const inputElement = document.getElementById(`${componentId}-input`);
              if (inputElement) {
                inputElement.focus();
              }
            }, 10);
          } else {
          }
          setIsOpen(prev => !prev);
        }}
        alignRight
      >
        <Dropdown.Toggle ref={refBtn} tabIndex={-1} disabled={disableDatePicker}>
          <div
            className="d-flex align-items-center hide-focus-outline date-picker-input"
            tabIndex={0}
          >
            {props.children}
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu
          ref={refMenu}
          style={props.DropdownMenuStyle}
          className={`date-picker ${props.menuClassName ?? ""}`}
          popperConfig={props.popperConfig}
          renderOnMount
        >
          <div className="wrapper " id={`hg-date-wrapper${componentId}`}>
            <div style={{ padding: '12px 12px 0 12px' }}>
              <input
                id={`${componentId}-input`}
                type="text"
                className="form-control highlight-input-with-grey-border "
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyPress={handleKeyPress}
                maxLength="10"
                onBlur={handleBlur}
              />
            </div>
            <header className="d-flex align-items-center justify-content-between">
              <YearMonthDropdown
                selectedYear={selectedYear}
                onYearChange={(year) => {
                  const date = moment(`${selectedMonth}/01/${year.value}`, 'MM/DD/YYYY').format(dateFormatFixed);
                  setSelectedDate(date);
                  props.onChange(date);
                }}
                selectedMonth={selectedMonth}
                onMonthChange={(month) => {
                  const date = moment(`${month.value}/01/${selectedYear}`, 'MM/DD/YYYY').format(dateFormatFixed);
                  setSelectedDate(date);
                  props.onChange(date);
                }}
              >
                <span className={`current-date ${componentId}`}></span>
              </YearMonthDropdown>
              <div className="icons">
                <span
                  id="prev"
                  className="material-symbols-rounded d-flex align-items-center justify-content-center"
                >
                  <img alt="" src="/images/chevron-left-cal.svg" />
                </span>
                <span
                  id="next"
                  className="material-symbols-rounded d-flex align-items-center justify-content-center"
                >
                  <img alt="" src="/images/chevron-right-cal.svg" />
                </span>
              </div>
            </header>
            <div className="calendar">
              <ul className="weeks">
                <li>Su</li>
                <li>Mo</li>
                <li>Tu</li>
                <li>We</li>
                <li>Th</li>
                <li>Fr</li>
                <li>Sa</li>
              </ul>
              <ul className={`days ${componentId}`}></ul>
            </div>
            <hr className="m-0 hg-border" />
            <div
              className="f-grey pl-4 p-3  pointer w-fit-content"
              onClick={() => {
                setSelectedDate(moment().format(dateFormatFixed));
                setUpdatedDate("");

                props.onChange("");
                document.body.click();
              }}
            >
              Clear
            </div>
          </div>
        </Dropdown.Menu>
      </Dropdown>
      {props?.isError && (<div className="f-danger f-12">{props?.errorText ? props?.errorText : 'Field cannot be empty'}</div>)}
    </div>
  );
};

export default MyDatePicker;
